export const LOADING_SHOW = 'containers/Loading/LOADING_SHOW';
export const LOADING_HIDE = 'containers/Loading/LOADING_HIDE';
